import { Helmet } from "react-helmet-async";

import { AppConfig } from "~/AppConfig";

export function ReditusHelmet(): JSX.Element | null {
  if (!AppConfig.REDITUS.URL || !AppConfig.REDITUS.UID) return null;

  const snippet = `
    (function (w, d, s, p, t) { 
      w.gr = w.gr || function () { 
        w.gr.ce = 60; 
        w.gr.q = w.gr.q || []; 
        w.gr.q.push(arguments); 
      }; 
      p = d.getElementsByTagName(s)[0]; 
      t = d.createElement(s); 
      t.async = true; 
      t.src = "${AppConfig.REDITUS.URL}"; 
      p.parentNode.insertBefore(t, p); 
    })(window, document, "script");
    gr("initCustomer", "${AppConfig.REDITUS.UID}");
    gr("track", "pageview");
  `;

  return (
    <Helmet>
      <script>{snippet}</script>
    </Helmet>
  );
}
